import { render, staticRenderFns } from "./CourseUsers.vue?vue&type=template&id=623d9c89"
import script from "./CourseUsers.vue?vue&type=script&lang=js"
export * from "./CourseUsers.vue?vue&type=script&lang=js"
import style0 from "./CourseUsers.vue?vue&type=style&index=0&id=623d9c89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports